/* eslint-disable */

import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
};

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(undefined);
  const [currentColor, setCurrentColor] = useState("#7352FF");
  const [currentMode, setCurrentMode] = useState("Light");
  const [themeSettings, setThemeSettings] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const [isClicked, setIsClicked] = useState(initialState);

  const setMode = (e) => {
    setCurrentMode(e.target.value);
    localStorage.setItem("themeMode", e.target.value);
  };

  const setColor = (color) => {
    setCurrentColor(color);
    localStorage.setItem("colorMode", color);
  };

  const handleClick = (clicked) => {
    // Only update the specific clicked state, don't reset others
    setIsClicked(prevState => ({ ...prevState, [clicked]: true }));
  };

  const closeDropdown = (dropdownName) => {
    // Close specific dropdown without affecting others
    setIsClicked(prevState => ({ ...prevState, [dropdownName]: false }));
  };

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider
              value={{
          currentColor,
          currentMode,
          activeMenu,
          screenSize,
          setScreenSize,
          handleClick,
          closeDropdown,
          isClicked,
          initialState,
          setIsClicked,
          setActiveMenu,
          setCurrentColor,
          setCurrentMode,
          setMode,
          setColor,
          themeSettings,
          setThemeSettings,
        }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
